import { render, staticRenderFns } from "./EditStatus.vue?vue&type=template&id=65d0e2d8"
import script from "./EditStatus.vue?vue&type=script&lang=js"
export * from "./EditStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports